import { useMemo } from 'react';
import { type CategorySelectorState } from '../../category-selector/hooks/useCategorySelector';
import { SubjectMobileSelection } from './SubjectMobileSelection';
import { SubSubjectMobileSelection } from './SubSubjectMobileSelection';
interface Props {
  categoryInfo: CategorySelectorState;
}

/**
 * 과목과 학습분야 선택을 함께 관리하는 모바일 컴포넌트
 *
 * - 과목과 학습분야를 세로로 배치
 * - 과목 선택 가능 여부 확인 (학년 미선택 시 과목만 표시)
 */
const SubjectCategoryMobileSection = ({
  categoryInfo
}: Props) => {
  const shouldShowSubjectSelect = useMemo(() => {
    if (categoryInfo.grade.gradeNodes?.length === 0) return true;
    if (!categoryInfo.grade.selectedGradeNode) return false;
    return !!categoryInfo.subject.subjectNodes && categoryInfo.subject.subjectNodes.length > 0;
  }, [categoryInfo.grade.gradeNodes?.length, categoryInfo.grade.selectedGradeNode, categoryInfo.subject.subjectNodes]);
  if (!shouldShowSubjectSelect) {
    return null;
  }
  return <>
      <SubjectMobileSelection categoryInfo={categoryInfo} data-sentry-element="SubjectMobileSelection" data-sentry-source-file="SubjectCategoryMobileSection.tsx" />
      <SubSubjectMobileSelection categoryInfo={categoryInfo} data-sentry-element="SubSubjectMobileSelection" data-sentry-source-file="SubjectCategoryMobileSection.tsx" />
    </>;
};
export { SubjectCategoryMobileSection };